import { Tag } from "lucide-react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

import Cartao from "../components/Cartao";

/** Nome e se a forma está ativa (o código é interno e não aparece). */
export default function SecaoIdentificacao({ d, criando }) {
  const { form, definir } = d;
  return (
    <Cartao titulo="Forma de pagamento" icone={Tag} e2e="secao-identificacao">
      <div className="space-y-4">
        <div>
          <Label>Nome *</Label>
          <Input value={form.name} onChange={(e) => definir("name", e.target.value)} placeholder="Ex.: Cartão de Crédito, PIX, Vale-refeição"
            className="mt-1" autoFocus={criando} data-e2e="campo-nome-forma" />
        </div>
        {/* O código da forma é só interno (dono, 30/09/2026): nasce do nome
            ao criar (lib/formulario.js) e nunca aparece na tela. */}
        <label className="flex items-center justify-between p-3 bg-muted rounded-lg cursor-pointer">
          <span className="text-sm font-medium">Forma ativa <span className="block text-[11px] font-normal text-muted-foreground">Desativada, some de todos os módulos mas continua nos relatórios.</span></span>
          <Switch checked={form.is_active} onCheckedChange={(v) => definir("is_active", v)} />
        </label>
      </div>
    </Cartao>
  );
}
